export enum CalendarExportMode {
  basic = "Basic",
  high = "High",
}